//@ts-ignore
import { OIDCClient as ApiClientOIDC } from "@fundwave/oidc-client";

import { config } from "../utils/common/constants";

const OIDCClientOptions = {
  baseUrl: config.openIdBaseUrl,
  refreshPath: "token/refresh"
};

export const OIDCClient = new ApiClientOIDC(OIDCClientOptions);
